const SharedModels = require('../../../shared/sharedModels');
const ReduxStore = require('./redux/reduxStore.jsx.js');
const baseURL = (typeof(window) !== 'undefined' ? window.location.origin : null) ;
const Toastr = require('toastr');
const AjaxFunctions = require('./ajaxFunctions');

exports.getGreySpaceCardsForCurrentEvidenceCard = function(){
   let curCard = ReduxStore.store.getState().EvidenceCardReducer.curCard;
   let curID = curCard.idEvidenceCard;

   if(!curID) return;
   $.get( baseURL + "/reasoning/getByEvidenceID?id=" + curID, (data) => {
      let processed = [];
      for(let row of data){
         if(row.evidenceCard1.idEvidenceCard === curID){
            row.evidenceCard1 = curCard;
            row.evidenceCard2 = ReduxStore.getEvidenceCardByID(row.evidenceCard2.idEvidenceCard);
         }
         else{
            row.evidenceCard2 = curCard;
            row.evidenceCard1 = ReduxStore.getEvidenceCardByID(row.evidenceCard1.idEvidenceCard);
         }
         processed.push(new SharedModels.GreySpaceCard(row));
      }
      ReduxStore.store.dispatch(
         ReduxStore.EvidenceCardFunctions.setCurrentCardField('greySpaceCards', processed)
      );
   })
      .fail(function(msg) {
         alert( msg.responseText );
      });
};

exports.deleteValueFromArray = function(value, array){
   for(let i = 0; i < array.length; i++){
      if(array[i] === value){
         array.splice(i,1);
         break;
      }
   }
};

exports.calculateUserLevel = function(points){
   if(points == 0){
      return 1
   }
   return (Math.floor((points - 1)/100) + 1)
};

exports.getPreviewFromText = function(text){
   if(window.globals.pageTestVersion === 'b'){
      return text;
   }
   if(!text) return '';
   let tokens = text.split(' ');
   let retString = '';
   for(let i = 0; i < 4 && i < tokens.length; i++){
      retString += tokens[i] + ' ';
   }
   return retString.trim();
};

exports.calculateBoundsForPoints = function(startPoint, endPoint){
   let left, right, top, bottom = 0;
   if(startPoint.x < endPoint.x){
      left = startPoint.x;
      right = endPoint.x;
   }
   else{
      left = endPoint.x;
      right = startPoint.x;
   }

   if(startPoint.y < endPoint.y){
      bottom = startPoint.y;
      top = endPoint.y;
   }
   else{
      bottom = endPoint.y;
      top = startPoint.y;
   }
   return {left, right, top, bottom};
};

exports.isPointInBounds = function(point, bounds){
   return (point.x >= bounds.left
      && point.x <= bounds.right
      && point.y >= bounds.bottom
      && point.y <= bounds.top
   );
};

exports.isCollision = function(rect1, rect2){
   return (rect1.x <= rect2.x + rect2.width &&
      rect1.x + rect1.width >= rect2.x &&
      rect1.y <= rect2.y + rect2.height &&
      rect1.height + rect1.y >= rect2.y);
};

exports.getParameterByName = function(name, url) {
   if (!url) return null;
   name = name.replace(/[\[\]]/g, "\\$&");
   let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
   if (!results) return null;
   if (!results[2]) return '';
   return decodeURIComponent(results[2].replace(/\+/g, " "));
};

exports.removeDuplicatesFromArrayByProp = function(inputArray, prop) {
   return inputArray.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
   });
};

exports.showError = function(errorText){
   Toastr.options.positionClass = 'toast-bottom-full-width';
   Toastr.error(errorText);
};

exports.getUpdatedPortfolioData = async function getUpdatedPortfolioData(){
   try {
      let portfolioData = await AjaxFunctions.getUserPortfolios();
      ReduxStore.store.dispatch(ReduxStore.PortfolioFunctions.setPortfolioList(portfolioData));
   }
   catch (e) {
      console.log(e);
      Toastr.error('Error getting updated data.');
   }

};

let currentlyUpdatingUserData = false;
exports.updateCurrentUserData = async function(bShouldSet = 1, needsReturnVal) {
   if(currentlyUpdatingUserData && !needsReturnVal) {
      return
   }
   currentlyUpdatingUserData = true;
   let userData = await AjaxFunctions.getCurrentUserData();
   let achievementMap = {};
   userData.achievements = userData.achievements || [];
   for (let achievement of userData.achievements) {
      achievementMap[achievement.idAchievement] = achievement;
   }

   if (!userData.user) userData.user = {};

   userData.user.achievements = achievementMap;
   userData.user.points = userData.points;
   userData.user.evidenceReviewCount = userData.evidenceReviewCount;
   userData.user.unreadPrivateMessageCount = userData.unreadPrivateMessageCount;
   userData.user.userEvidenceCount = userData.userEvidenceCount;
   userData.user.socialNetwork = userData.socialNetwork;
   userData.user.pointsAvailableToBet = userData.pointsAvailableToBet;

   if(bShouldSet) {
      ReduxStore.store.dispatch(ReduxStore.UserFunctions.setCurUser(userData.user));
   }

   currentlyUpdatingUserData = false;
   return userData.user;
};

exports.createUrlForCard = function(id, cardType) {
   return `${window.location.origin}/listView?cardType=${cardType}&idCard=${id}&cModalOpen=1`;
}

exports.createUrlForPortfolioTab = function(tabName) {
   let url = window.location.pathname + window.location.search;
   if (url.includes('initialTab=')) {
      let split = url.split('initialTab=');
      split[1] = split[1].replace(/\w+/, tabName);
      url = split.join('initialTab=');
   } else {
      url += `&initialTab=${tabName}`
   }
   return url;
};

exports.createUrlForPortfolioComment = function(idComment) {
   let url = window.location.pathname + window.location.search;
   if (url.includes('idComment=')) {
      let split = url.split('idComment=');
      split[1] = split[1].replace(/\w+/, idComment);
      url = split.join('idComment=');
   } else {
      url += `&idComment=${idComment}`;
   }
   return window.location.host + url;
};

exports.formatComments = function(comments) {
   pComments = comments.filter(c => c.idParentComment == null);
   pComments.forEach(comment => loadComments(comments, comment));
   return pComments;
};

function loadComments(comments, pComment) {
   comments.forEach(comment => {
      comment.shouldExpand = false;
      if (comment.idParentComment == pComment.idCardComment) {
         pComment.childComments.push(comment);
         loadComments(comments, comment);
      }
   });
}

exports.buildFilterObject = (startDate) => {
   let topicFilterArray = ReduxStore.store.getState().EditorReducer.topicFilterArray;
   let deckFilterArray = ReduxStore.store.getState().EditorReducer.idDeckFilterArray;
   let cardTypes = ReduxStore.store.getState().EditorReducer.cardTypeFilterArray;

   let filterObject = {};

   if(startDate){
      filterObject.fromDate = startDate;
   }

   if(topicFilterArray.length > 0){
      filterObject.topics = topicFilterArray.map(t => t.value);
   }
   else if(deckFilterArray.length > 0){
      filterObject.idDeck = deckFilterArray[0].value;
   }

   if(cardTypes.length > 0){
      filterObject.cardTypes = cardTypes;
   }

   let searchString = ReduxStore.store.getState().EditorReducer.searchString;
   if(searchString.trim() !== ''){
      filterObject.searchString = searchString;
   }

   return filterObject;
}

exports.initialCardFetch = async function(startDate, shouldAppend) {
   let filterObject = exports.buildFilterObject(startDate);
   let data = await AjaxFunctions.getFilteredCardData(filterObject);
   if(shouldAppend)
      ReduxStore.appendCardData(data);
   else{
      ReduxStore.processCardData(data);
   }
   return ReduxStore.store.getState().CardReducer.cardList;
}
